// Implements: F-RPT-005
/**
 * Mockup v3 P9: the cost rows of one report grouped by currency, each with its share of THAT
 * currency's total (money is never added across currencies). Pure.
 *
 * The share is a whole-number percentage (`Math.round`); a currency whose total is zero reads 0 %
 * for every row, never `NaN`. Currencies keep the order the report first names them in.
 */

export interface CostedRow {
  readonly currency: string;
  readonly cost_micros: number;
}

export interface CurrencyGroup<R extends CostedRow> {
  readonly currency: string;
  readonly rows: readonly { readonly row: R; readonly share: number }[];
}

export function byCurrency<R extends CostedRow>(rows: readonly R[]): CurrencyGroup<R>[] {
  const groups = new Map<string, R[]>();
  for (const row of rows) groups.set(row.currency, [...(groups.get(row.currency) ?? []), row]);
  return Array.from(groups, ([currency, members]) => {
    const total = members.reduce((sum, row) => sum + row.cost_micros, 0);
    return {
      currency,
      rows: members.map((row) => ({ row, share: total <= 0 ? 0 : Math.round((row.cost_micros / total) * 100) })),
    };
  });
}
